import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

import appActions from '../../actions/actions';
import multipleAccountsActions from '../../actions/multipleAccounts';
import MultipleAccounts from './MultipleAccounts';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', ''),
        emailAddress: get(state, 'app.userEmailAddress', ''),
        integratedBrandsPrimarySiteList: get(state, 'app.integratedBrandsPrimarySiteList', []),
        translations: state.app.translations,
        serviceError: get(state, 'multipleAccounts.serviceError', ''),
        userType: get(state, 'app.userType', ''),
        isConsolidationRequired: get(state, 'app.isConsolidationRequired', true)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        multipleAccountsActions: bindActionCreators(multipleAccountsActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class MultipleAccountsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.props.appActions.enableLoadOverLay(false);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Multiple Accounts Page');
    }

    handleMultipleAccountsSelection = (event, primarySite) => {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue'
        }, {});
        const selectedAccountDetails = {
            primarySite,
            userType: this.props.userType,
            isConsolidationRequired: this.props.isConsolidationRequired
        }
        // add onboarding message service -> on success PPM_IDENTIFIED status along with site selected
        this.props.multipleAccountsActions.selectAccount(selectedAccountDetails);
    }

    handleAlertDismiss() {
        this.props.multipleAccountsActions.dismissAlertBox();
    }

    render() {
        return (
            <MultipleAccounts publicUuid={this.props.publicUuid}
                translations={this.props.translations}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                integratedBrandsPrimarySiteList={this.props.integratedBrandsPrimarySiteList}
                emailAddress={this.props.emailAddress}
                handleMultipleAccountsSelection = {this.handleMultipleAccountsSelection}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
            />
        );
    }
}

MultipleAccountsContainer.propTypes = {
    publicUuid: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};
MultipleAccountsContainer.defaultProps = {
    publicUuid: '-1'
};
